import { render, staticRenderFns } from "./BHeader.vue?vue&type=template&id=5fc0adc3&scoped=true"
import script from "./BHeader.vue?vue&type=script&lang=js"
export * from "./BHeader.vue?vue&type=script&lang=js"
import style0 from "./BHeader.vue?vue&type=style&index=0&id=5fc0adc3&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0adc3",
  null
  
)

export default component.exports